<template>
  <div class="action-menu float-right">
    <b-dropdown right class="action-menu" variant="link" toggle-class="text-decoration-none">
      <template #button-content>
        <small>Actions</small><br />
        <feather type="layers"></feather>
      </template>
      <b-dropdown-item href="#" @click.prevent="viewTransaction()" v-if="!transactionOpen"><feather type="book-open"></feather> Open Transaction</b-dropdown-item>
      <b-dropdown-item href="#" @click.prevent="doAction('approve')" v-if="transaction.action === 'approve'"><feather type="check-circle"></feather> Approve Transaction</b-dropdown-item>
      <b-dropdown-item href="#" @click.prevent="doPayment()" v-if="transaction.action === 'fund'"><feather type="dollar-sign"></feather> Fund Transaction</b-dropdown-item>
      <b-dropdown-item href="#" @click.prevent="acceptAs(null)" v-if="transaction.action === 'link' && companies.length === 0"><feather type="check-circle"></feather> Approve Transaction</b-dropdown-item>
      <b-dropdown-item href="#" @click.prevent="acceptAs(null)" v-if="transaction.action === 'link' && companies.length > 0"><feather type="check-circle"></feather> Approve as {{ userStore.user.name }}</b-dropdown-item>
      <div v-if="transaction.action === 'link' && companies.length > 0">
        <b-dropdown-item href="#" @click.prevent="acceptAs(company._id)" v-for="company in companies" :key="company._id"><feather type="check-circle"></feather> Approve as {{ company.name }}</b-dropdown-item>
      </div>
      <b-dropdown-item href="#" v-if="transaction.payment_status === 'Verifying' && isEFTPayment === true" @click.prevent="$bvModal.show('choose_banks')"><feather type="tablet"></feather> View Truzo Bank Details</b-dropdown-item>
      <div v-if="transaction.action === 'deliver-milestone' && deliveringMilestones.count > 0">
        <b-dropdown-item href="#" @click.prevent="doAction('deliver-milestone', milestone.id)" v-for="milestone in deliveringMilestones.items" :key="milestone._id"><feather type="truck"></feather> Deliver <strong>{{ milestone.name }}</strong>, <small>due on {{ milestone.due_date | moment('MMMM Do, YYYY') }}</small></b-dropdown-item>
      </div>
      <b-dropdown-item href="#" v-if="transaction.action === 'deliver-milestone' && deliveringMilestones.count > deliveringMilestones.items.length" @click.prevent="viewTransaction()"><feather type="truck"></feather> Open Transaction to Deliver Other Milestones</b-dropdown-item>
      <b-dropdown-item href="#" v-if="transaction.action === 'deliver'" @click.prevent="doAction('deliver')"><feather type="truck"></feather> Deliver Transaction</b-dropdown-item>
      <div v-if="transaction.action === 'release-milestone' && releasingMilestones.count > 0">
        <b-dropdown-item href="#" @click.prevent="doAction('release-milestone', milestone.id)" v-for="milestone in releasingMilestones.items" :key="milestone._id"><feather type="dollar-sign"></feather> Release <strong>{{ milestone.name }}</strong>, <small>delivered on {{ milestone.payment_requested_date | moment('MMMM Do, YYYY') }}</small></b-dropdown-item>
      </div>
      <b-dropdown-item href="#" v-if="transaction.action === 'release-milestone' && releasingMilestones.count > releasingMilestones.items.length" @click.prevent="viewTransaction()"><feather type="truck"></feather> Open Transaction to Release Other Milestones</b-dropdown-item>
      <b-dropdown-item href="#" v-if="transaction.action === 'release'" @click.prevent="doAction('release')"><feather type="dollar-sign"></feather> Release Transaction Funds</b-dropdown-item>
      <b-dropdown-item href="#" @click.prevent="doEdit()" v-if="canEdit"><feather type="edit"></feather> Edit Transaction</b-dropdown-item>
      <b-dropdown-item href="#" @click.prevent="doAction('cancel')" v-if="transaction.action === 'link'"><feather type="x-circle"></feather> Reject Transaction</b-dropdown-item>
      <b-dropdown-item href="#" @click.prevent="doAction('cancel')" v-else-if="transaction.status !== 'Cancellation Requested' && transaction.status !== 'Completed' && !transaction.disputed"><feather type="x-circle"></feather> Cancel Transaction</b-dropdown-item>
      <b-dropdown-item href="#" @click.prevent="doAction('cancel')" v-else-if="transaction.status === 'Cancellation Requested' && !myCancellation"><feather type="x-circle"></feather> Confirm Cancellation</b-dropdown-item>
      <b-dropdown-item href="#" @click.prevent="disputeTransaction()" v-if="canDispute && (this.isDelivered || this.isMilestoneDelivered)"><feather type="alert-circle" class="text-danger"></feather><span class="text-danger"> Dispute Transaction</span></b-dropdown-item>
    </b-dropdown>
    <b-modal :id="'dispute_' + transaction._id" size="md" centered hide-header hide-footer>
      <button type="button" aria-label="Close" class="close" @click="$bvModal.hide('dispute_' + transaction._id)">×</button>
      <h3 class="color-navy-blue mb-4">Dispute Transaction</h3>
      <b-form>
        <b-form-group>
          <maz-select v-model="dispute.reason" placeholder="Reason for Dispute" clearable required :success="dispute.reason !== null" :options="dispute.reasons"></maz-select>
        </b-form-group>
        <b-form-group>
          <maz-select v-model="dispute.action" placeholder="Required Action" clearable required :success="dispute.action !== null" :options="dispute.actions"></maz-select>
        </b-form-group>
        <b-form-group>
          <maz-input v-model="dispute.comments" placeholder="Additional Comments" clearable :success="dispute.comments != null" textarea></maz-input>
        </b-form-group>
        <p>
          We encourage all our users to negotiate directly to resolve any issues to avoid costly arbitration fees. By choosing to negotiate offline, the inspection days will automatically be paused for 5 days.
        </p>
        <hr />
        <b-form-group>
          <b-form-checkbox v-model="dispute.accepted" id="t-c" name="checkbox" value="accepted">I have read the dispute resolution <a href="https://truzo.com/terms-and-conditions/" target="_blank">Terms &amp; Conditions</a> in full and am fully aware that an arbitration fee must be paid before the dispute process can begin and that the decision of the arbitrator is final.</b-form-checkbox>
        </b-form-group>
        <b-form-group>
          <b-row>
            <b-col cols="12" md="6">
              <loading-button :replace="loading.negotiate === true">
                <b-button type="button" @click="doAction('negotiate')" variant="outline-success" pill block class="mt-3" v-if="!transaction.offline_negotiation">Negotiate Offline</b-button>
              </loading-button>
            </b-col>
            <b-col cols="12" md="6">
              <loading-button :replace="loading.dispute === true">
                <b-button type="button" @click="doAction('dispute')" variant="custom" pill block class="mt-3" :disabled="!(dispute.accepted && dispute.reason && dispute.action)">Submit Dispute</b-button>
              </loading-button>
            </b-col>
          </b-row>
        </b-form-group>
      </b-form>
    </b-modal>
    <banks-modal :currency="transaction.amounts.currency"></banks-modal>
  </div>
</template>

<script>
import BanksModal from '../modals/BanksModal.vue'

import { transactionService } from './../../services'
import { mapActions, mapState } from 'vuex'

export default {
  props: {
    transaction: Object
  },
  components: {
    BanksModal
  },
  data () {
    return {
      loading: {
        negotiate: false,
        dispute: false
      },
      dispute: {
        reason: null,
        reasons: [
          { value: 'Not Received', label: 'Not Received' },
          { value: 'Damaged', label: 'Damaged' },
          { value: 'Not as Ordered', label: 'Not as Ordered' },
          { value: 'Other', label: 'Other' }
        ],
        action: null,
        actions: [
          { value: 'Resend', label: 'Resend' },
          { value: 'Return', label: 'Return' },
          { value: 'Refund', label: 'Refund' },
          { value: 'Other', label: 'Other' }
        ],
        comments: null,
        accepted: false
      }
    }
  },
  computed: {
    ...mapState({
      auth: state => state.auth.user,
      actions: state => state.txnActions,
      company: state => state.company,
      userStore: state => state.auth.user
    }),
    transactionOpen () {
      if (this.$route.path === '/transaction') {
        return true
      } else {
        return false
      }
    },
    actionStatus () {
      return this.actions.status
    },
    companies () {
      if (this.company && this.company.companies) {
        return this.company.companies.filter(company => company.verified)
      } else {
        return []
      }
    },
    role () {
      if (this.transaction) {
        if (this.transaction.actors.buyer && this.transaction.actors.buyer._id === this.auth.user.id) {
          return 'buyer'
        } else if (this.transaction.actors.seller && this.transaction.actors.seller._id === this.auth.user.id) {
          return 'seller'
        } else if (this.transaction.actors.buyer_company && this.transaction.actors.buyer_company._id === this.auth.user.company) {
          return 'buyer'
        } else if (this.transaction.actors.seller_company && this.transaction.actors.seller_company._id === this.auth.user.company) {
          return 'seller'
        } else {
          return 'agent'
        }
      } else {
        return null
      }
    },
    myCancellation () {
      if (this.transaction.status === 'Cancellation Requested') {
        if (this.role === 'buyer' && this.transaction.cancellations.buyer) {
          return true
        } else if (this.role === 'seller' && this.transaction.cancellations.seller) {
          return true
        } else if (this.role === 'agent' && this.transaction.cancellations.agents && this.transaction.cancellations.agents.length > 0) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    deliveringMilestones () {
      if (this.transaction.project && this.transaction.project.items && this.transaction.project.items.length > 0) {
        const _items = this.transaction.project.items.filter(_item => !_item.payment_requested && !_item.payment_released)
        _items.sort((a, b) => a.due_date - b.due_date)
        if (_items.length > 3 && !this.transactionOpen) {
          return {
            items: _items.slice(0, 3),
            count: _items.length
          }
        } else {
          return {
            items: _items,
            count: _items.length
          }
        }
      } else {
        return { items: [], count: 0 }
      }
    },
    releasingMilestones () {
      if (this.transaction.project && this.transaction.project.items && this.transaction.project.items.length > 0) {
        const _items = this.transaction.project.items.filter(_item => _item.payment_requested && !_item.payment_released)
        _items.sort((a, b) => a.due_date - b.due_date)
        if (_items.length > 3 && !this.transactionOpen) {
          return {
            items: _items.slice(0, 3),
            count: _items.length
          }
        } else {
          return {
            items: _items,
            count: _items.length
          }
        }
      } else {
        return { items: [], count: 0 }
      }
    },
    canEdit () {
      if (this.isGeneralOrProject) {
        if (this.transaction.status === 'In Approvals' || this.transaction.status === 'Approved') {
          if (this.transaction.project && this.transaction.project.items.length > 0) {
            let _allow = true
            this.transaction.project.items.forEach(item => {
              if (item.payment_requested || item.payment_released) {
                _allow = false
              }
            })

            return _allow
          } else {
            return true
          }
        } else {
          return false
        }
      } else if (this.transaction.vehicle && this.transaction.vehicle.make && this.transaction.vehicle.price > 0) {
        if (this.transaction.status === 'In Approvals' || this.transaction.status === 'Approved') {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    isGeneralOrProject () {
      if (this.transaction.general && this.transaction.general.items.length > 0) {
        return true
      } else if (this.transaction.project && this.transaction.project.items.length > 0) {
        return true
      } else {
        return false
      }
    },
    isDelivered () {
      return this.transaction.payment_requested
    },
    isMilestoneDelivered () {
      if (this.transaction.type && this.transaction.type.name === 'project') {
        let _delivered = false
        this.transaction.project.items.forEach(_item => {
          if (_item.payment_requested) {
            _delivered = true
          }
        })

        return _delivered
      } else {
        return false
      }
    },
    canDispute () {
      if (this.transaction.disputed) {
        return false
      } else {
        return this.transaction.status !== 'Completed' && true
      }
    },
    isEFTPayment () {
      if (this.transaction) {
        const _selected = this.transaction.amounts.fees.find(_fee => _fee.selected === true)
        if (_selected) {
          if (_selected.method && _selected.method.name === 'EFT') {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      } else {
        return false
      }
    }
  },
  mounted () {
    if (this.company.status !== 'loaded') {
      this.getAll()
    }
  },
  methods: {
    ...mapActions('alert', {
      setSuccess: 'success',
      setError: 'error'
    }),
    ...mapActions('auth', ['logout']),
    ...mapActions('company', ['getAll']),
    ...mapActions('social', {
      showSocialShare: 'show',
      hideSocialShare: 'hide'
    }),
    ...mapActions('transactionLinks', ['getLinked']),
    ...mapActions('transactionNew', ['clear', 'update']),
    ...mapActions('transactionSelected', {
      setTransactions: 'setTransactions'
    }),
    ...mapActions('transaction', {
      loadIn: 'loadIn'
    }),
    ...mapActions('txnActions', ['accept', 'action']),
    doEdit: async function () {
      const self = this
      transactionService.startEdit(this.transaction._id)
        .then(_edit => {
          if (_edit) {
            if (_edit.status === 'Updated') {
              self.setSuccess('This transaction was updated by ' + _edit.created_by.personal.first_names + ' ' + _edit.created_by.personal.surname + '. Please, select the transaction again to view the updates.')
              self.$router.push('/home')
            } else {
              if (_edit.created_by._id === self.auth.user.id) {
                const _tx = JSON.parse(JSON.stringify(this.transaction))
                if (_tx.coupon) {
                  _tx.coupon = _tx.coupon.short_code
                }
                if (this.transaction.general && this.transaction.general.items.length > 0) {
                  const type = 'goods'
                  this.update({
                    type: type,
                    role: this.role,
                    transaction: _tx
                  })
                  this.$router.push('/transaction/edit')
                } else if (this.transaction.project && this.transaction.project.items.length > 0) {
                  const type = 'services'
                  this.update({
                    type: type,
                    role: this.role,
                    transaction: _tx
                  })
                  this.$router.push('/transaction/edit')
                } else if (this.transaction.vehicle && this.transaction.vehicle.make && this.transaction.vehicle.price > 0) {
                  const type = 'vehicle'
                  this.update({
                    type: type,
                    role: this.role,
                    transaction: _tx
                  })
                  this.$router.push('/transaction/edit')
                } else {
                  return false
                }
              } else {
                self.setError('You cannot edit this transaction as it\'s been edited by ' + _edit.created_by.personal.first_names + ' ' + _edit.created_by.personal.surname + '. Please, wait for them to finish their changes before trying to edit this transaction.')
              }
            }
          } else {
            const _tx = JSON.parse(JSON.stringify(this.transaction))
            if (_tx.coupon) {
              _tx.coupon = _tx.coupon.short_code
            }
            if (this.transaction.general && this.transaction.general.items.length > 0) {
              const type = 'goods'
              this.update({
                type: type,
                role: this.role,
                transaction: _tx
              })
              this.$router.push('/transaction/edit')
            } else if (this.transaction.project && this.transaction.project.items.length > 0) {
              const type = 'services'
              this.update({
                type: type,
                role: this.role,
                transaction: _tx
              })
              this.$router.push('/transaction/edit')
            } else if (this.transaction.vehicle && this.transaction.vehicle.make && this.transaction.vehicle.price > 0) {
              const type = 'vehicle'
              this.update({
                type: type,
                role: this.role,
                transaction: _tx
              })
              this.$router.push('/transaction/edit')
            } else {
              return false
            }
          }
        })
        .catch(error => {
          console.log(error)
          self.setError('We were unable to verify whether this transaction is being edited by another party at this time. Please, try again ...')
        })
    },
    doPayment: function () {
      const self = this
      transactionService.getEdit(this.transaction._id)
        .then(_edit => {
          if (_edit) {
            if (_edit.status === 'Updated') {
              self.setSuccess('This transaction was updated by ' + _edit.created_by.personal.first_names + ' ' + _edit.created_by.personal.surname + '. Please, select the transaction again to view the updates.')
              self.$router.push('/home')
            } else if (_edit.status === 'Inactive') {
              self.loadIn(self.transaction)
              self.$router.push('/transaction/payment')
            } else {
              if (_edit.created_by._id === self.auth.user.id) {
                self.loadIn(self.transaction)
                self.$router.push('/transaction/payment')
              } else {
                self.setError('You cannot fund this transaction as it\'s been edited by ' + _edit.created_by.personal.first_names + ' ' + _edit.created_by.personal.surname + '. Please, wait for them to finish their changes before trying to fund this transaction.')
              }
            }
          } else {
            self.setError('We were unable to verify whether this transaction is being edited by another party at this time. Please, try again ...')
          }
        })
        .catch(error => {
          console.log(error)
          self.setError('We were unable to verify whether this transaction is being edited by another party at this time. Please, try again ...')
        })
    },
    doAction: function (action) {
      const _params = {
        action: action,
        id: this.transaction._id
      }

      if (action === 'negotiate') {
        this.loading.negotiate = true
      } else if (action === 'dispute') {
        this.loading.dispute = true
      }

      if (action === 'deliver-milestone') {
        _params.milestoneId = this.transaction.project.items.find(item => item.payment_requested === false).id
      } else if (action === 'release-milestone') {
        _params.milestoneId = this.transaction.project.items.find(item => (item.payment_requested && item.payment_released === false)).id
      } else if (action === 'dispute') {
        _params.params = {
          reason: this.dispute.reason,
          action: this.dispute.action,
          comments: this.dispute.comments
        }
      }

      this.action(_params)
    },
    setLoadingFalse: function () {
      this.loading = {
        negotiate: false,
        dispute: false
      }
    },
    acceptAs: function (company) {
      this.accept({ id: this.transaction.link._id, transaction: this.transaction._id, company: company })
      setTimeout(() => {
        this.getLinked()
      }, 500)
    },
    viewTransaction: function () {
      this.setTransactions(this.transaction)
      this.$router.push('/transaction')
    },
    disputeTransaction: function () {
      if (this.canDispute && (this.isDelivered || this.isMilestoneDelivered)) {
        this.$bvModal.show('dispute_' + this.transaction._id)
      }
    }
  },
  watch: {
    actionStatus (_new, _old) {
      if (_new === 'loaded' || _new === 'not-found' || _new === 'saved') {
        if (this.actions && this.actions.result) {
          this.$bvModal.hide('dispute')
          console.log(this.actions.result)
          this.setLoadingFalse()

          if (this.actions.result.status === 'Completed') {
            this.showSocialShare()
          }
        }
      }
    }
  }
}
</script>
